import { Inject, Injectable, computed, signal } from '@angular/core';
import { TTheme } from '@models/colors.model';
import { THEME_STORAGE_KEY } from '@constants/index';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

export const themeState = signal('dark');
export const isDarkMode = computed(() => themeState() === 'dark');

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_STORAGE_KEY = THEME_STORAGE_KEY;

  private _theme = new BehaviorSubject<TTheme>('dark');

  set theme(theme: TTheme) {
    themeState.set(theme);
    this.document.documentElement.className = theme;
    localStorage.setItem(this.THEME_STORAGE_KEY, theme);
    this._theme.next(theme);
  }

  get theme$(): Observable<TTheme> {
    return this._theme.asObservable();
  }

  constructor(@Inject(DOCUMENT) private document: Document) {}
}
